module.exports = __webpack_public_path__ + "static/media/raceschedule.ebbb01bc.jpg";